import * as React from "react";
import { Room, connect, LocalTrack, TwilioError } from "twilio-video";

export function useTwilioRoom(errCallback: (err: TwilioError) => void) {
	const [twilioRoom, setTwilioRoom] = React.useState<Room>();
	const [isConnecting, setIsConnecting] = React.useState<boolean>(false);

	const connectTwilio = React.useCallback(
		async (accessToken: string, localTracks: LocalTrack[] | undefined) => {
			setIsConnecting(true);
			try {
				let room;
				if (localTracks !== undefined) {
					room = await connect(accessToken, { tracks: localTracks });
				} else {
					room = await connect(accessToken, { video: false, audio: false });
				}

				const disconnect = () => room.disconnect();

				room.once("disconnected", () => {
					window.removeEventListener("beforeunload", disconnect);
				});

				// Add a listener to disconnect from the room when a user closes their browser
				window.addEventListener("beforeunload", disconnect);

				setTwilioRoom(room);
				return room;
			} catch (err) {
				errCallback(err);
			} finally {
				setIsConnecting(false);
			}
		},
		[errCallback],
	);
	return { twilioRoom, connectTwilio, isConnecting };
}
